import React from 'react';
import { useDashboardData } from '../data/DashboardDataProvider';

const numberOfVideos = 200;

const VideoItem = ({ videoId, right, moreRight }) => (
  <div style={{ display: 'flex', alignItems: 'center', paddingTop: 4, paddingBottom: 4, borderBottom: '1px solid #eee' }}>
    <img
      src={`https://img.youtube.com/vi/${videoId}/default.jpg`}
      alt={videoId}
      style={{ width: 60, height: 45, marginRight: 12, borderRadius: 4, objectFit: 'cover' }}
    />
    <span style={{ flex: 1, fontFamily: 'monospace', fontSize: '0.8rem' }}>{videoId}</span>
    <span style={{ fontWeight: 600, marginRight: 8 }}>{right}</span>
    {moreRight && <span style={{ color: 'rgb(123, 128, 154)' }}>{moreRight}</span>}
  </div>
);

const YoutubeImports = () => {
  const { youtubeData, errors } = useDashboardData();
  const { topYoutubeImports, failedYoutubeImports } = youtubeData;

  return (
    <section>
      {(errors.topYoutubeImports || errors.failedYoutubeImports) && (
        <div className="alert alert-error">{errors.topYoutubeImports}</div>
      )}
      <div className="chart-grid">
        <div className="chart-col">
          <div className="card">
            <div className="chart-card-header"><span className="chart-card-title">Top {numberOfVideos} users (and analyses) per video</span></div>
            <div style={{ maxHeight: '80vh', overflow: 'auto', padding: '1rem' }}>
              {topYoutubeImports.data.slice(0, numberOfVideos).map(({ video_id, users, count }) => (
                <VideoItem key={video_id} videoId={video_id} right={users} moreRight={`(${count})`} />
              ))}
            </div>
          </div>
        </div>
        <div className="chart-col">
          <div className="card">
            <div className="chart-card-header"><span className="chart-card-title">Started videos that did not display</span></div>
            <div style={{ maxHeight: '80vh', overflow: 'auto', padding: '1rem' }}>
              {failedYoutubeImports.data.filter(v => v.song_ready < 1).slice(0, numberOfVideos).map(({ video_id, count }) => (
                <VideoItem key={video_id} videoId={video_id} right={count} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YoutubeImports;
